import { render, staticRenderFns } from "./List.vue?vue&type=template&id=d7833f44&scoped=true&"
var script = {}
import style0 from "./List.vue?vue&type=style&index=0&id=d7833f44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7833f44",
  null
  
)

export default component.exports